// src/pages/PayBridge.jsx
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { chargeCoin } from "../api/app/appService";

function submitForm({ url, method = "POST", data = {} }) {
  const form = document.createElement("form");
  form.method = method.toUpperCase();
  form.action = url;
  form.style.display = "none";
  form.target = "_top"; // PWA/WebView 較穩

  Object.entries(data).forEach(([k, v]) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = k;
    input.value = v == null ? "" : String(v);
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
}

export default function PayBridge() {
  const nav = useNavigate();
  const { state } = useLocation(); // 由上一頁傳入 { amount, storeId }

  useEffect(() => {
    (async () => {
      try {
        if (!state?.amount || !state?.storeId) {
          nav(-1);
          return;
        }
        // 直接在橋接頁呼叫 API
        const res = await chargeCoin({
          points: Number(state.amount),
          storeId: String(state.storeId),
        });

        const url = res?.payload?.properties?.url;
        const method = res?.payload?.properties?.method || "POST";
        const data = res?.payload?.data;

        if (!url || !data) {
          alert("付款參數錯誤");
          nav(-1);
          return;
        }
        // 送出到金流
        submitForm({ url, method, data });
      } catch (err) {
        if (err?.code === "UNAUTHORIZED") {
          nav("/login");
          return;
        }
        alert("前往金流失敗");
        nav(-1);
      }
    })();
  }, [nav, state]);

  return (
    <div style={{ padding: 24, fontFamily: "system-ui, -apple-system, Segoe UI, Roboto" }}>
      <h3>正在前往金流頁面</h3>
      <p>請稍候，不要關閉此頁。</p>
    </div>
  );
}
